import React, { Component } from 'react';
import Header from '../../Header';
import MessageLink from '../../MessageLink';
import Footer from '../../Footer';
import PageDescriptionDenuncias from '../../PageDescription/Denuncias';
import BannerSingle from '../../BannerSingle';
import Lgpd from '../../Lgpd';
import ErrorBoundary from '../../ErrorHandler/ErrorBoundary';
import Helper from "../../Helper";


interface ComponentProps {
	page?: string;
}

interface ComponentState {
	isLoaded: boolean;
	result: any[];
}

class Denuncias extends Component<ComponentProps, ComponentState> {

	private helper: Helper;

	constructor(props: ComponentProps) {
		super(props);
		this.state = {
			isLoaded: false,
			result: []
		};
		this.helper = new Helper(this);
	}

	componentDidMount() {
		this.helper.init('canal-de-denuncia');
	}

	componentDidUpdate(prevProps: ComponentProps, prevState: ComponentState) {
		if (this.state.result.length > 0 && prevState.result !== this.state.result) {
			document.title = this.state.result[0]?.Title;
		}
	}
	

	render() {
		return (
			<div>
				{/* HEADER */}{/* LOGIN */}
				<ErrorBoundary><Header /></ErrorBoundary>
				<main>

					<ErrorBoundary><BannerSingle image={"Denuncias"} page={"canal-de-denuncia"} items={this.state.result} /></ErrorBoundary>
					{/* Page description */}
					<ErrorBoundary><PageDescriptionDenuncias page={"canal-de-denuncia"} items={this.state.result}/></ErrorBoundary>
					{/* Content page */}

				</main>
				{/* FOOTER */}
				<ErrorBoundary><Footer /></ErrorBoundary>
				{/* Message Link */}
				<ErrorBoundary><MessageLink /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>
			</div>
		);
	}
};

export default Denuncias;